export interface IRib {
  codeIban?: string;
  client?: string;
  etabbq?: string;
  guichet?: string;
  numeroCompte?: string;
  cleRib?: string;
  codeBic?: string;
  domiciliation?: string;
  ville?: string;
  pays?: string;
  devise?: string;
}

export class Rib implements IRib {
  constructor(
    public codeIban?: string,
    public client?: string,
    public etabbq?: string,
    public guichet?: string,
    public numeroCompte?: string,
    public cleRib?: string,
    public codeBic?: string,
    public domiciliation?: string,
    public ville?: string,
    public pays?: string,
    public devise?: string
  ) {
  }
}
